import WFlatCard from './WFlatCard'
import { createSimpleFunctional } from '../../util/helpers'

const WFlatCardActions = createSimpleFunctional('w-flat-card__actions')
const WFlatCardSubtitle = createSimpleFunctional('w-flat-card__subtitle')
const WFlatCardText = createSimpleFunctional('w-flat-card__text')
const WFlatCardTitle = createSimpleFunctional('w-flat-card__title')

export {
  WFlatCard,
  WFlatCardActions,
  WFlatCardSubtitle,
  WFlatCardText,
  WFlatCardTitle,
}

export default {
  $_ifrontui_subcomponents: {
    WFlatCard,
    WFlatCardActions,
    WFlatCardSubtitle,
    WFlatCardText,
    WFlatCardTitle,
  },
}
